export const products = {
  free: {
    priceId: 'price_1RNeN0RtB0k9odPOLiyuzoGx',
    name: 'Free Plan',
    description: 'Try our full AI-powered content analysis with 1 analysis per week. Get the same comprehensive report as paid plans with limited usage.',
    mode: 'subscription' as const,
    price: 0,
    features: [
      'Complete AI content analysis',
      '1 analysis per week',
      'Community support (48h response)'
    ],
    legacyPriceIds: []
  },
  starter: {
    priceId: 'price_1RVuUgRtB0k9odPOYQvIvTFE',
    name: 'Starter Plan',
    description: 'Get our full AI-powered content analysis with 30 analyses per month. Perfect for consistent creators who want to optimize every post.',
    mode: 'subscription' as const,
    price: 19.99,
    features: [
      'Complete AI content analysis',
      '30 analyses per month',
      'Standard support (24h response)'
    ],
    legacyPriceIds: ['price_1RNeJ9RtB0k9odPOZOlFvv7E']
  },
  pro: {
    priceId: 'price_1RVuMHRtB0k9odPOjG7ZM5I0',
    name: 'Pro Plan',
    description: 'Unlimited access to our full AI-powered content analysis plus exclusive PostAlgo feature to analyze your already-posted videos.',
    mode: 'subscription' as const,
    price: 49.99,
    features: [
      'Complete AI content analysis',
      'Unlimited analyses per month',
      'Exclusive PostAlgo feature for post-publishing analysis',
      'Priority support (4h response)'
    ],
    legacyPriceIds: ['price_1RNeJzRtB0k9odPODs7oq09t']
  }
};